import { Pipe, PipeTransform } from "@angular/core";
import { AppConstants } from "../constants/constants";

@Pipe({
  name: "sortBy",
})
export class ArraySortPipe implements PipeTransform {
  transform(array: any, field: string, order: string): any[] {
    if (!Array.isArray(array)) {
      return;
    }

    if (order == AppConstants.ASCENDING || !order) {
      let arr = [...array].sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
      return arr;
    } else if (order == AppConstants.DESCENDING) {
      array.sort((a: any, b: any) => 0 - (a[field] > b[field] ? -1 : 1));
      return array;
    } else {
      return null;
    }
  }
}
